import trips from './list/reducers'
import downloadTrips from './download/reducers'

export default {
  trips,
  downloadTrips,
}
